// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_List from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as ValidationUtils from "../../../../../../../pricing-dashboard/view/components/library/utils/ValidationUtils.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormSelectWithCheckboxInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectWithCheckboxInput.bs.js";

function ValidationTypeSelector(Props) {
  var validationType = Props.validationType;
  var isSelected = Props.isSelected;
  var onChange = Props.onChange;
  return React.createElement(FormSelectWithCheckboxInput$Catalyst.make, {
              input_props: FormInput$Catalyst.make_props("", onChange, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
              select_props: {
                selected: isSelected ? ({
                      hd: validationType,
                      tl: /* [] */0
                    }) : /* [] */0,
                options: ValidationUtils.toCheckBoxOptions(Belt_List.fromArray([validationType])),
                renderValue: undefined
              }
            });
}

var make = ValidationTypeSelector;

export {
  make ,
  
}
/* react Not a pure module */
